import { Dashboard } from '@ih/app/shared/apis/interfaces';

export class FindAllDashboardsSuccess {
  public static readonly type =
    '[Project/Dashboard/List] FindAllDashboardsSuccess';
  constructor(public readonly dashboards: Dashboard[]) {}
}
